module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_close02-ff9f4101f2d92d8be79a89d6caf869b0.svg";